/**
 * Maximum length for an inspection note or recommendation string. Enforced client-side
 * before save across web and mobile; the server returns 400 on violation. Shared here so
 * every consumer references a single source of truth rather than redeclaring the literal.
 */
export const NOTE_OPTION_MAX_LENGTH = 250;

/**
 * Setting key (a SettingKey enum member NAME) that carries whether an inspection must be reviewed
 * before it can be transferred. Read from the branch-scoped settings map in
 * {@link ApplicationContextStore}; the string value is 'true'/'false'. Shared here so every
 * consumer references a single source of truth rather than redeclaring the literal.
 */
export const INSPECTION_REVIEW_GATE_SETTING_KEY = 'RequireInspectionReviewBeforeTransfer';

/**
 * Setting key (a SettingKey enum member NAME) that carries whether template designers may mark a
 * section so its failed items transfer as one job. Read from the branch-scoped settings map in
 * {@link ApplicationContextStore}; the string value is 'true'/'false'. The template editor hides the
 * switch while this is off.
 */
export const GROUPED_FINDINGS_TRANSFER_SETTING_KEY = 'GroupedFindingsTransfer';
